import { ColDef } from '@ag-grid-enterprise/all-modules'
import i18n from '@/lang/i18n'
import { initialCrudModelBaseState, CrudModelPaginatorLaboratory } from '@/shared/models/cruds.models'
import { ConfigurationProtocolResponse } from '@/modules/configurationModule/detail/local-assays/protocols/services/configuration-protocol/configuration-protocol.dto'
import { configurationProtocolService } from '@/modules/configurationModule/detail/local-assays/protocols/services/configuration-protocol/configuration-protocol.service'
import { AgGridColumnType } from '@/shared/models/ag-grid.model'
import { PaginatorLaboratoryDatasource } from '@/shared/resources/datasources/paginator/paginator-laboratory-datasource'
import { store } from '@/store/store'

export const columnsDefLocalAssayProtocolGrid =
    (): ColDef[] => [
        { type: AgGridColumnType.CUSTOM_CHECKBOX },
        {
            type: AgGridColumnType.TEXT,
            headerName: i18n.tc('configuration.sections.protocol'),
            colId: 'prtName',
            field: 'name',
            minWidth: 300,
            flex: 1,
            suppressSizeToFit: true,
            sortable: false
        },
        {
            type: AgGridColumnType.TEXT,
            headerName: i18n.tc('configuration.grid.portionType'),
            field: 'portionType.potName',
            minWidth: 300,
            flex: 1,
            suppressSizeToFit: true,
            sortable: false
        },
        {
            type: AgGridColumnType.CHECK_ICON,
            headerName: i18n.tc('configuration.grid.active'),
            colId: 'prtActive',
            field: 'active',
            minWidth: 80,
            suppressSizeToFit: true
        }
    ]

export interface ConfigurationLocalAssaysProtocolsGridState extends CrudModelPaginatorLaboratory<ConfigurationProtocolResponse> {
    service: typeof configurationProtocolService
    laboratoryId: number
}
export const initialConfigurationLocalAssaysProtocolsGridState =
    (): ConfigurationLocalAssaysProtocolsGridState => ({
        ...initialCrudModelBaseState(),
        gridUiComponent: 'uicomponent.configuration.local.assays.assaysProtocols',
        columnsDef: columnsDefLocalAssayProtocolGrid(),
        datasource: new PaginatorLaboratoryDatasource(configurationProtocolService, store.getters.labId),
        service: configurationProtocolService,
        laboratoryId: store.getters.labId
    })
